import React from "react";
import { GOOGLE_API_KEY } from "../../../config/Keys";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from "react-google-maps";
import { compose, withProps, withStateHandlers } from "recompose";
const { InfoBox } = require("react-google-maps/lib/components/addons/InfoBox");

const googleMapsApiKey = GOOGLE_API_KEY;

const SelectMapLocation = compose(
  withProps({
    googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${googleMapsApiKey}&v=3.exp&libraries=geometry,drawing,places`,
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `400px` }} />,
    mapElement: <div style={{ height: `100%` }} />,
    center: { lat: 20.593683, lng: 78.962883 },
  }),
  withStateHandlers(
    () => ({
      isOpen: false,
    }),
    {
      onToggleOpen:
        ({ isOpen }) =>
        () => ({
          isOpen: !isOpen,
        }),
    }
  ),
  withScriptjs,
  withGoogleMap
)((props) => (
  <GoogleMap
    defaultZoom={5}
    defaultCenter={props.center}
    onClick={props.onSelectLocation}
  >
    {props.location.markers.length ? (
      props.location.markers.map((marker, i) => (
        <Marker
          position={marker}
          icon={{
            url: require("../../../assets/images/UserManagement/map-pin.svg"),
          }}
        >
          <InfoBox>
            <div
              style={{
                backgroundColor: `white`,
                opacity: 0.75,
                padding: `2px`,
              }}
            >
              <div style={{ fontSize: `11px` }}>{props.location.list[i]}</div>
            </div>
          </InfoBox>
        </Marker>
      ))
    ) : (
      <></>
    )}
  </GoogleMap>
));

export default SelectMapLocation;
